<template>
  <ModalButton
    modal-class="edit-event-form-modal"
    :modal-visible="isEditingEvent"
    @toggle="onToggle"
  >
    <template #button>
		<span class="btn btn-util square-32">

			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.875 16.875H7.50003L3.16479 12.5398"/><path stroke="#004ADB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.5 16.875H3.75C3.5842 16.875 3.4253 16.8092 3.3081 16.692 3.1909 16.5748 3.125 16.4158 3.125 16.25V12.7589C3.125 12.6768 3.1412 12.5956 3.1726 12.5197 3.204 12.4439 3.25 12.375 3.3081 12.317L12.6831 2.942C12.8003 2.8248 12.9592 2.7589 13.125 2.7589 13.2908 2.7589 13.4497 2.8248 13.5669 2.942L17.0581 6.4331C17.1753 6.5503 17.2411 6.7093 17.2411 6.875 17.2411 7.0408 17.1753 7.1998 17.0581 7.317L7.5 16.875ZM10.625 5 15 9.375M7.5 16.8743 3.1648 12.5391"/></svg>
		</span>
	</template>
	<template #modal-title>Edit Event Details</template>
    <template #modal-content>
      <EditEventForm
        :input-model="event"
        :confirm-discard="confirmDiscard"
        verb="Save Changes"
        ref="form"
        @save="onSave"
      >
        <template #actions>
			<button class="btn btn-large btn-hover-red" @click="reset">Discard Changes</button>
        </template>
      </EditEventForm>
      <p class="center">
        <DeleteEventButton
          v-model="event"
          class="button-inline button-danger"
          :redirect="{ name: $routes.Dashboard.name }"
        />
      </p>
    </template>
  </ModalButton>
</template>

<script>
import DeleteEventButton from '@/components/jobs/DeleteEventButton';
import EditEventForm from '@/components/forms/EditEventForm';
import JobEvent from '@/models/JobEvent';

export default {
  name: 'EditEventButton',
  components: { DeleteEventButton, EditEventForm },
  model: {
    prop: 'event',
    event: 'save',
  },
  props: {
    event: {
      type: JobEvent,
      required: true,
    },
  },
  data() {
    return {
      /** @type {boolean} */
      confirmDiscard: true,
      /** @type {boolean} */
      isEditingEvent: false,
    };
  },
  methods: {
    /**
     * @param {JobEvent} event
     * @returns {void}
     */
    onSave(event) {
      this.reset();
      this.$emit('save', event);
    },
    /**
     * @param {boolean} isEditingEvent
     * @returns {void}
     */
    onToggle(isEditingEvent) {
      if (isEditingEvent) {
        this.confirmDiscard = true;
        this.isEditingEvent = true;
        return;
      }
      const { form } = this.$refs;
      let canDiscardChanges;
      if (
        !form ||
        typeof (canDiscardChanges = form.canDiscardChanges) !== 'function' ||
        canDiscardChanges.call(form)
      ) {
        this.isEditingEvent = false;
      }
    },
    /**
     * @returns {void}
     */
    reset() {
      this.confirmDiscard = false;
      this.isEditingEvent = false;
    },
  },
};
</script>
